import React, { useState } from "react";
import { addAppointment } from "../services/firestore";
import { toast } from "react-toastify";
import { FaUser, FaPhone, FaEnvelope, FaCalendarAlt, FaHome, FaStickyNote } from "react-icons/fa";

const Form = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    dob: "",
    todaysDate: "",
    type: "",
    lookingFor: "",
    notes: "",
    status: "Pending",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addAppointment(formData);
      toast.success("Appointment added successfully!");
      setFormData({
        name: "",
        phone: "",
        email: "",
        dob: "",
        todaysDate: "",
        type: "",
        lookingFor: "",
        notes: "",
        status: "Pending",
      });
    } catch (error) {
      toast.error("Failed to add appointment!");
    }
  };

  return (
    <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-4xl mx-auto animate-fade-in">
      <h2 className="text-xl font-bold mb-6 text-gray-800 text-center">
        <FaCalendarAlt className="inline-block text-blue-500 mr-2" />
        Add Details
      </h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Name <FaUser className="inline-block text-gray-500 ml-1" />
          </label>
          <input
            type="text"
            name="name"
            className="w-full p-3 border rounded-lg focus:outline-blue-500 transition-all"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        {/* Phone */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Phone <FaPhone className="inline-block text-gray-500 ml-1" />
          </label>
          <input
            type="text"
            name="phone"
            className="w-full p-3 border rounded-lg focus:outline-blue-500 transition-all"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email <FaEnvelope className="inline-block text-gray-500 ml-1" />
          </label>
          <input
            type="email"
            name="email"
            className="w-full p-3 border rounded-lg focus:outline-blue-500 transition-all"
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        {/* DOB and Today's Date */}
        <div className="space-y-4 md:flex md:space-y-0 md:space-x-4">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Date of Birth <FaCalendarAlt className="inline-block text-gray-500 ml-1" />
            </label>
            <input
              type="date"
              name="dob"
              className="w-full p-3 border rounded-lg focus:outline-blue-500 transition-all"
              value={formData.dob}
              onChange={handleChange}
            />
          </div>
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Today's Date <FaCalendarAlt className="inline-block text-gray-500 ml-1" />
            </label>
            <input
              type="date"
              name="todaysDate"
              className="w-full p-3 border rounded-lg focus:outline-blue-500 transition-all"
              value={formData.todaysDate}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Type and Looking For */}
        <div className="space-y-4 md:flex md:space-y-0 md:space-x-4 items-center">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Type of House/Business <FaHome className="inline-block text-gray-500 ml-1" />
            </label>
            <input
              type="text"
              name="type"
              className="w-full p-3 border rounded-lg focus:outline-blue-500 transition-all"
              value={formData.type}
              onChange={handleChange}
            />
          </div>
          <div className="flex items-center space-x-4">
            <label className="flex items-center text-gray-700">
              <input
                type="radio"
                name="lookingFor"
                value="Residential"
                className="mr-2 focus:outline-blue-500 transition-all"
                checked={formData.lookingFor === "Residential"}
                onChange={handleChange}
              />
              Residential
            </label>
            <label className="flex items-center text-gray-700">
              <input
                type="radio"
                name="lookingFor"
                value="Commercial"
                className="mr-2 focus:outline-blue-500 transition-all"
                checked={formData.lookingFor === "Commercial"}
                onChange={handleChange}
              />
              Commercial
            </label>
          </div>
        </div>

        {/* Notes */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Notes <FaStickyNote className="inline-block text-gray-500 ml-1" />
          </label>
          <textarea
            name="notes"
            className="w-full p-3 border rounded-lg focus:outline-blue-500 transition-all"
            value={formData.notes}
            onChange={handleChange}
          ></textarea>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-600 transition-all font-semibold text-lg"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default Form;
